import { useState } from 'react'
import { Check } from 'lucide-react'
import {
  Combobox,
  ComboboxContent,
  ComboboxTrigger,
} from 'tailwind-v4/components/popover-combobox'
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandItem,
  CommandList,
} from 'tailwind-v4/components/command'
import { SquareSvgIcon } from '@/ux/icons/square'
import { SwitcherChevron } from '@/components/nav-v4/switcher-chevron'
import { useSquareEntitySelection } from '@/components/nav-v4/use-square-entity-selection'

/**
 * Old-UI Square entity picker — the exact same combobox pill as the shared
 * VenueSwitcher (borderless trigger + up/down chevron) so it sits identically
 * beside it in the old top bar, with the Square logo inside the trigger. The
 * dropdown carries `old-ui-nav` so its surface themes with the old top bar.
 */
export function OldSquareEntityPicker({ orgId }: { orgId: string }) {
  const [open, setOpen] = useState(false)
  const { integrations, selected, select } = useSquareEntitySelection(orgId)
  if (integrations.length === 0) return null

  return (
    <Combobox open={open} onOpenChange={setOpen}>
      <ComboboxTrigger className="font-medium">
        <SquareSvgIcon className="size-4 shrink-0 text-[var(--foreground)]" />
        <span className="min-w-0 max-w-[160px] truncate">
          {selected?.merchant_name ?? 'Square account'}
        </span>
        <SwitcherChevron />
      </ComboboxTrigger>
      <ComboboxContent className="old-ui-nav">
        <Command shouldFilter={false}>
          <CommandList>
            <CommandEmpty>No Square accounts.</CommandEmpty>
            <CommandGroup>
              {integrations.map((i) => (
                <CommandItem
                  key={i.id}
                  value={i.id}
                  onSelect={() => {
                    select(i.id)
                    setOpen(false)
                  }}
                  className="data-[selected=true]:bg-[var(--accent)] data-[selected=true]:text-[var(--accent-foreground)]"
                >
                  <SquareSvgIcon className="size-4 shrink-0 text-[var(--foreground)]" />
                  <span className="truncate">{i.merchant_name}</span>
                  {i.id === selected?.id ? (
                    <Check className="ml-auto size-4" />
                  ) : null}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </ComboboxContent>
    </Combobox>
  )
}
